module.exports = __webpack_public_path__ + "img/ic-warning-red.2c7c5db5.svg";